import { BlobItem, BlobServiceClient, ContainerClient } from '@azure/storage-blob';

const sas = process.env.REACT_APP_BLOB_STORAGE_SAS || '';
const containerName = process.env.REACT_APP_BLOB_STORAGE_CONTAINER || '';

const createContainerClient = (): ContainerClient => {
    const blobServiceClient = new BlobServiceClient(sas);
    const containerClient = blobServiceClient.getContainerClient(containerName);
    return containerClient;
};

export const uploadFileToBlob = async (file: File) => {
    const containerClient = createContainerClient();
    const blobClient = containerClient.getBlockBlobClient(file.name);
    
    // if (!(await containerClient.exists())) {
        //     // console.error(`Container "${containerName}" does not exist.`);
        //     toast.error(`Container "${containerName}" does not exist.`)
        //     return;
        //   }
        
        try {
        await blobClient.uploadData(file);
        // console.log(`File uploaded successfully: ${file.name}`);
    } catch (error) {
        console.error('Error uploading file:', error);
    }
};

export const getListOfBlobsInContainer = async (): Promise<BlobItem[]> => {
    const containerClient = createContainerClient();
    const fileList: BlobItem[] = [];
    try {
        for await (const blob of containerClient.listBlobsFlat()) {
            fileList.push(blob);
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error fetching blob list: ', error);
        throw new Error('Could not fetch blob list.');
    }
    return fileList;
};

export const deleteBlob = async (blobName: string): Promise<void> => {
    const containerClient = createContainerClient();
    const blobClient = containerClient.getBlockBlobClient(blobName);

    // console.log('BLOB NAME: ', blobName)
    try {
        await blobClient.delete();
        console.log(`Blob "${blobName}" deleted successfully.`);
    } catch (error) {
        console.error(`Error deleting blob "${blobName}":`, error);
        throw new Error(`Failed to delete blob: ${blobName}`);
    }
};

export const deleteAllBlobs = async (): Promise<void> => {
    const containerClient = createContainerClient();
    try {
        for await (const blob of containerClient.listBlobsFlat()) {
            const blobClient = containerClient.getBlockBlobClient(blob.name);
            await blobClient.delete();
            console.log(`Blob "${blob.name}" deleted.`);
        }
        console.log('All blobs deleted successfully.');
    } catch (error) {
        console.error('Error deleting blobs:', error);
        throw new Error('Failed to delete all blobs.');
    }
};
